import { supabase } from "@/integrations/supabase/client";

export async function uploadBlogCoverImage(file: File): Promise<string> {
  // Determine extension from file type - preserve original format (no compression)
  const extMap: Record<string, string> = {
    "image/png": "png",
    "image/jpeg": "jpg",
    "image/webp": "webp",
    "image/gif": "gif",
    "image/svg+xml": "svg",
  };
  const ext = extMap[file.type] || "png";
  const fileName = `covers/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;

  const { error } = await supabase.storage
    .from("blog-images")
    .upload(fileName, file, {
      contentType: file.type,
      cacheControl: "31536000", // 1 year cache
      upsert: false,
    });

  if (error) throw error;

  const { data: urlData } = supabase.storage
    .from("blog-images")
    .getPublicUrl(fileName);

  return urlData.publicUrl;
}
